// The backend stores the source page clean, so the campaign follows the alert's current slug.
export const sourcePageHref = (url, slug) => {
    if (!url) return null;
    try {
        const tagged = new URL(url);
        // The API only accepts https, but the CMS can write the column directly.
        if (tagged.protocol !== 'https:') return null;
        tagged.searchParams.set('utm_source', 'newspage');
        tagged.searchParams.set('utm_medium', 'alert');
        if (slug) tagged.searchParams.set('utm_campaign', slug);
        return tagged.toString();
    } catch {
        return null;
    }
};

// Paid placements are rel="sponsored"; a link an expert sets for free is user-generated.
export const sourcePageRel = (isSponsored) =>
    `${isSponsored ? 'sponsored' : 'ugc'} noopener`;

export const sourcePageText = (label, url) => {
    if (label) return label;
    try {
        return new URL(url).hostname.replace(/^www\./, '');
    } catch {
        return url;
    }
};

export const SOURCE_LABEL_MAX = 60;

export const pickSource = (alert) => ({
    sourceUrl: alert?.sourceUrl || '',
    sourceLabel: alert?.sourceLabel || '',
    isSponsored: !!alert?.isSponsored,
    sourceBy: alert?.sourceBy || '',
});
